/* eslint-disable import/prefer-default-export */
/* eslint-disable no-async-promise-executor */
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

import { API_URL } from '@/data/constants';

type RequestParams = {
  url?: string;
  options?: AxiosRequestConfig;
  [key: string]: string | AxiosRequestConfig | undefined;
}

export default class HttpService {
  BASE_URL: string = API_URL;
  TIMEOUT_MS = 10000;

  instance: AxiosInstance = axios.create({
    baseURL: this.BASE_URL,
    timeout: this.TIMEOUT_MS,
    headers: {
      'Content-Type': 'application/json',
    },
  })

  public async get<T>(requestParams: RequestParams): Promise<AxiosResponse<T>> {
    const params = {
      url: requestParams.url || '/',
      options: requestParams.options,
    };

    return new Promise(async (resolve, reject) => {
      const { url, options } = params;

      try {
        const req = this.instance.get(url, options ? { ...options } : undefined);
        return resolve(req);
      } catch (error) {
        return reject(error);
      }
    });
  }
}
